export default __webpack_public_path__ + "static/media/hostfully_step12.7fb079cf.png";